import { Component } from '@angular/core';

@Component({
  selector: 'jb-signin-skeleton',
  templateUrl: './signin-skeleton.component.html',
  styleUrls: ['./signin-skeleton.component.scss'],
})
export class SigninSkeletonComponent {}
